import { getDefaultStore } from "jotai";

import {
  activeMeasurementToolAtom,
  previousDrawingToolAtom,
  type MeasurementToolMode,
} from "../../atoms/measurementAtoms";
import { registerCommand } from "./registry";

const isDrawingTool = (t: MeasurementToolMode) =>
  t === "lasso" || t === "bump" || t === "regionGrow";

registerCommand("setActiveTool", ({ tool }) => {
  const store = getDefaultStore();
  const current = store.get(activeMeasurementToolAtom);

  // "none" (HU/window-level) is the explicit exit-to-default — clear without
  // arming previousDrawing, so pressing W twice doesn't resurrect a lasso.
  if (tool === "none") {
    store.set(activeMeasurementToolAtom, "none");
    store.set(previousDrawingToolAtom, null);
    return;
  }

  // Pressing the same tool key twice restores the drawing tool that was
  // active before, so "ruler → ruler" returns the rad to lasso, not to none.
  const previousDrawing = store.get(previousDrawingToolAtom);
  if (current === tool) {
    store.set(activeMeasurementToolAtom, previousDrawing ?? "none");
    store.set(previousDrawingToolAtom, null);
    return;
  }

  if (isDrawingTool(current)) {
    store.set(previousDrawingToolAtom, current);
  }
  store.set(activeMeasurementToolAtom, tool);
});
